import { UrlGetParams } from 'consts'
import { getActiveCampaignFromStorage } from 'utils/sessionStorage'

const isRecommendedProduct = (urlParams: URLSearchParams) => {
  if (!urlParams.has(UrlGetParams.Product)) return false

  const pzn = urlParams.get(UrlGetParams.Product)

  const activeCampaign = getActiveCampaignFromStorage()

  return Boolean(activeCampaign?.consultProductsOffered?.includes(pzn))
}

export default isRecommendedProduct
